import { useLocation } from "react-router-dom";
import { PageSkeleton } from "@ui";
import { ShellSkeleton } from "@ui/layout";
import RoutePreloader from "@shared/components/loading/RoutePreloader";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import { readLastLogin } from "@screens/login/lastLogin";
import { ADD_ENTRIES, FOOTER, PRIMARY, SECONDARY } from "./navEntries";

export function WorkspaceLoading() {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  if (readLastLogin() === null) return <RoutePreloader force />;

  const activeId = [...PRIMARY, ...SECONDARY, ...FOOTER].find((entry) => pathname.startsWith(entry.id))?.id ?? null;

  return (
    <ShellSkeleton
      primary={PRIMARY}
      secondary={SECONDARY}
      footer={FOOTER}
      addEntries={ADD_ENTRIES}
      activeId={activeId}
      compact={isMobile}
    >
      <PageSkeleton compact={isMobile} />
    </ShellSkeleton>
  );
}
